@use "sass:meta";
@use "../../../globals/bcp";
@use "../../../globals/bcp-2022/objects/button-badge";
@use "../../../globals/settings";

:host {
  @include button-badge.button-badge-parent();
}

.f-button-with-badge__icon {
  display: flex;

  @if meta.global-variable-exists(button-gap, settings) {
    gap: bcp.size(settings.$button-gap);
  }

  &-reverse {
    flex-direction: row-reverse;
  }
}

f-badge {
  @include button-badge.button-badge-position();
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
